const year = '2025';

const summary = `
    I'm really excited to set my 2025 reading goal at 48 books! I enjoyed picking up so many new books last year, and there are 
    already so many more books that I know I want to read. Check out my 2025 TBR stack, below, I already have a collection of books 
    I can't wait to read throughout the year. You can find my 2025 reading list at the bottom of this page, where I'll be adding books 
    as I finish reading them. What books are you looking forward to reading this year? Let me know if you have any book recommendations!

    —January 18, 2025: Kicking Off 2025 with Thrills and Inspiration—

    [Some thoughts on: "The Christmas Fix", "The Hunting Party", and "Be Ready When the Luck Happens"]

    As I'm writing this, I've finished reading "The Christmas Fix" by Lucy Score and "The Hunting Party" by Lucy Foley. "The 
    Christmas Fix" was gifted to me for Christmas. I'd never read a book by Lucy Score and did not have any idea what I was in 
    store for. It's a romance novel where hurricane disaster relief plus HGTV-like reality show drama meets spicy small-town romance. 
    There was a good amount of plot development setup in the first half of the book, followed by a sudden level-ten dial-up of 
    romantic plotting toward the end.

    I also enjoyed reading the fast-paced thriller, "The Hunting Party" by Lucy Foley. I previously enjoyed reading Foley's "The 
    Guest List". After "The Guest List", I knew I could count on Foley as one of my go-to thriller authors, and "The Hunting Party" 
    did not disappoint. The plot of this book occurs over less than a week and is set around New Year's—it was timely to be reading 
    this at the start of the year. A group of friends who met at Oxford reunite for their annual holiday getaway at a remote 
    location when secrets, tension, and murder fall upon them. The book had me guessing until the very end about what exactly led 
    to the murder, who the victim was, and who did it.

    Currently, I'm also listening to "Be Ready When the Luck Happens: A Memoir" by Ina Garten. I'm thoroughly enjoying listening to 
    Ina tell her entire journey to where she is in life today. In general, I enjoy memoirs to learn personal stories and be reminded 
    of the challenges we all face, and how individuals almost always come out stronger and wiser on the other end. I love cooking, 
    the Food Network, and hearing about personal career journeys, so I am thoroughly enjoying this book. I'm convinced I now have 
    to look more into the Barefoot Contessa's cookbooks, television show, and more. I'm even more convinced I need to plan my return 
    trip to France after hearing about Ina's Paris adventure of a lifetime.

    Up next, I'm about to start reading the third installment in The Housemaid series by Freida McFadden, "The Housemaid is 
    Watching". I just picked up the copy I had on hold at the library. Once I finish this book, maybe I'll finally pick up a book 
    off my TBR stack!

    —February 21, 2025: Vanity, Habits, and Modern Love—

    [Some thoughts on: "The Housemaid is Watching", "The Picture of Dorian Gray", "Atomic Habits", "Everything I Know About Love", and "How to End a Love Story"]

    This winter has provided perfect moments where I can settle into my cozy apartment on a snowy day with a book! I closed out 
    January with mixed feelings about "The Housemaid is Watching." While it provided closure for the characters I'd followed through 
    the series, the plot was not what I expected for the characters now fifteen years into the future, and I didn't think it was as 
    thrilling as the first two installments. I also finally completed Britney Spears' memoir, which offered a fascinating glimpse 
    into her journey and the challenges she's faced in becoming the artist and person she is today.

    February began with a literary classic—Oscar Wilde's "The Picture of Dorian Gray." I purchased this haunting novel during my 
    travels in Ireland last April. I was intrigued and curious knowing it was Wilde's only full-length novel. The Victorian prose 
    was challenging to follow at first, but I soon found myself captivated by the dark psychological portrait Wilde paints of vanity 
    and moral corruption. What struck me most was how timeless the themes remain—our obsession with youth and beauty, and the often 
    hidden consequences of moral compromise.

    Next, I read "Atomic Habits" by James Clear. It's a book I've had since 2021, and I'm pretty familiar with the concepts of the 
    book. This was the first time I read it cover-to-cover, and I thoroughly enjoyed it. I think it's nice to pick up a book with 
    strategies to maintain good habits as we progress through the year. I set plenty of goals at the end of 2024, and I want 
    reminders and new strategies to consistently keep me on track. Clear's practical approach to building small habits that lead 
    to remarkable results resonated with me, especially his framework of making habits obvious, attractive, easy, and satisfying.

    In the spirit of February and Valentine's Day, I read "Everything I Know About Love" from my TBR list! This memoir by Dolly 
    Alderton was funny, heartfelt, and provided insights into friendships over time. Although I cannot even remotely compare my 
    experiences from my teen years to my late-twenties to those of Alderton, I thoroughly enjoyed learning about her completely 
    different experiences growing up and navigating love and friendships while realizing that many of the emotions and feelings 
    she's experienced still resemble mine in navigating the same sort of relationships in life. Her raw honesty about the messiness 
    of relationships and growing up in the digital age made this a perfect February read.

    To close out this lovey-dovey month, I've started reading "How to End a Love Story" by Yulin Kuang. I found out about this book 
    seeing that it was a Reese's Book Club pick, and I've always enjoyed the books on that list. I also read that Kuang is both the 
    adapting writer and director for the "Beach Read" film and the screenwriter for the "People We Meet On Vacation" film. Emily 
    Henry is one of my top contemporary romantic fiction authors, and I could not be more excited to read something from someone 
    so directly involved in the book-to-screen adaptations of Henry's books. "How to End a Love Story" follows two characters with 
    a tragic history who end up having to work together in Hollywood. When I read the blurb for the book, it reminded me a little of 
    "Romantic Comedy" (which I loved!) by Curtis Sittenfeld, in the sense that the story follows TV writers and there's potential 
    for romance between characters. So far, I'm hooked and I can't wait to see where the story takes our main characters.

    As February draws to a close, I'm delighted to see my 2025 reading challenge progressing nicely with eight books completed in 
    the first two months. The variety in my selections—from classic literature to self-improvement, from celebrity memoirs to 
    romantic comedies—reflects exactly what I love about reading: the ability to step into completely different worlds and 
    perspectives with each new book. I'm looking forward to what March brings to my bookshelf—maybe some picks from the Barnes & 
    Noble Book Festival?? Wink wink ;) Until next month's update, happy reading!

    —March 31, 2025: From Outer Space to a Time-Slip Romance—

    [Some thoughts on: "How to End a Love Story", "Orbital", "The Seven Year Slip", "Master of Me", "Harry Potter and the Prisoner of Azkaban", and the Barnes & Noble Book Festival]

    Looking back at my last blog post, I can see how excited I was to follow the character development of our main characters in 
    “How To End a Love Story”. I'd seen online that this book had an enemies-to-lovers romance trope, and while I usually enjoy 
    that type of storyline, I have to admit that the plot of the story and where the characters ended up was not my favorite. At 
    times, I was uncomfortable with the choices our characters were making given their shared history. However, I think that there 
    were parts of the story that were profound. Without giving away any spoilers, I can share that I think that any reader would 
    definitely be impacted by the characters' deep emotions around grief and love. I often felt confused, had mixed emotions, and 
    perhaps confusion is exactly what these characters were experiencing when navigating different life situations. It was definitely 
    hard for me to accept the fate of the main characters by the end of the story. Despite this, if you're looking to shake things up 
    with a book that is different from your typical romance then this might be your cup of tea.

    To kick off the month of March, I read “Orbital” by Samantha Harvey. I learned about this book from following NYT Books 
    (@nytbooks) on Instagram. It was the Book Review Book Club pick for February, and there is an accompanying podcast episode that 
    comes out by the end of month for these monthly reading picks. This was my first time reading along. Not being part of an actual 
    book club myself, I thought this could be fun! I typically end up sharing all my book thoughts with my sister (if we're reading 
    the same book) or my boyfriend (he has no choice but to hear me out haha). I thought the premise of the book sounded interesting, 
    as it follows six astronauts and cosmonauts doing research in space while lapping planet Earth multiple times within 24 hours, 
    and I won't lie, the fact that the book won the Booker Prize last year motivated me to pick it up.

    Upon doing some research, I found that the Booker Prize dates back to 1969, and the award has been given annually to the best 
    novel written in English, published in the UK or Ireland—the rules have changed over the years, but these seem to be the most 
    up-to-date qualifications. I also found that I've read another Booker Prize award-winning book—"Life of Pi" by Yann Martel. 
    I've also read books from other Booker Prize award-winning authors and nominees, including "The Handmaid's Tale" by Margaret 
    Atwood and "Lucy by the Sea" by Elizabeth Strout.

    “Orbital” surprised me. It's a short book, so I thought it would be a quick read. I was so wrong! It's a small but mighty book, 
    and I found myself being able to read only a few pages at a time. Sometimes, I'd reread the same sentences a couple of times 
    because of how beautiful they were—whether it was a description of space, Earth, or of the dreams or passionate desires of these 
    individuals to be in space staring back down at Earth. I, too, felt while reading this book that I was watching Earth from a 
    distance. Those frequent descriptions of the land masses passing below them were so descriptive and, at times, unlike anything 
    I've ever read. I especially favored following one astronaut's storyline—Chie, the Japanese astronaut—more than the others', but 
    each one contributed an interesting story and set of values that made the book what it is. By the end, I was left with a lot to 
    think about, including what my place and purpose on Earth is relative to the entire universe. Listening to The Book Review podcast 
    episode was a great follow-up to reading “Orbital”, as many of the thoughts discussed aligned with how I felt about reading the 
    book, and I felt that I had better closure on what I'd just read.

    Next up, I read “The Seven Year Slip” by Ashley Poston. I absolutely loved this novel, and I am claiming that it's my favorite 
    book I've read so far this year. I read this book in anticipation of meeting the author for their book signing at the Union 
    Square Barnes & Noble Book Festival that happened earlier this month. I'd had high hopes for this book sitting on my TBR shelf, 
    aging like fine wine, and it did not disappoint! My favorite romance books are love stories where the writing is romantic and 
    magical, the “spicy” scenes are tasteful and not overly explicit, and the characters undergo phenomenal character growth and 
    development that leaves me feeling proud of them by the end of the story. I love that this book is set in New York City, my home 
    for the past 10+ years. I love that the main characters' professions are in book publishing and cooking. And as a food lover, I 
    love all the food references and descriptions.

    Nearly every description of absolutely anything in this book—person, place, or thing—is made out to be magical. I felt like I 
    was reading a modern-day fairytale. There are also themes of grief, healing, time, and change—this book has it all. There were 
    many quotes that I took away with me, one of my favorites being, "There was something just so reassuring about books. They had 
    beginnings and middles and ends, and if you didn't like a part, you could skip to the next chapter. If someone died, you could 
    stop on the last page before, and they'd live on forever. Happy endings were definite, evils defeated, and the good lasted 
    forever." I feel it helps capture the essence of this book so well. All of this is to say that after reading “The Seven Year 
    Slip”, I was overjoyed to go to the author's book signing. I got my book signed and received a copy of Poston's “A Novel Love 
    Story” with my ticket. I also picked up Poston's “The Dead Romantics”, and I'm thrilled to now have these all signed and to be 
    able to read these additional books later this year.

    As mentioned in my last reading update, I was going to be attending the Barnes & Noble Book Festival this month. I attended Day 2 
    of the B&N Book Festival. This was my first year attending and I sadly did not get a ticket for Day 1 (they probably sold out in 
    a minute). Day 1 was mainly an opportunity to pick up a bunch of advanced reading copies. Instead, I purchased tickets to attend 
    two author book signings on Day 2. The first book signing was for Ashley Poston and the second was for Jeneva Rose. Last year, 
    I read “The Perfect Marriage” by Jeneva Rose, and I thoroughly enjoyed reading this thriller. My sister, an avid thriller fan, 
    is also a fan of Rose's. We're both excited for the forthcoming sequel to “The Perfect Marriage”—“The Perfect Divorce”. With my 
    ticket, I received a copy of the B&N exclusive edition of her book “Home Is Where the Bodies Are”.

    Ultimately, I enjoyed both of the author signings and receiving a book at each meeting, but I will admit that I was not prepared
    to be standing for three hours. I've attended other book events at the Union Square B&N, but none have involved solely attending 
    for a book signing, and there is typically a discussion followed by a book signing. I knew there wouldn't be author discussions 
    for these events, but seeing that the events were advertised as being part of the Book Festival, I had assumed that B&N had other 
    treats or freebies in store for readers. Whether or not I attend this Book Festival in the future would probably depend on the 
    authors in attendance, and on whether B&N can facilitate a better ticketing system for Day 1, when all the advanced reading 
    copies are distributed and publishers hand out merchandise. We shall see!

    The audiobook I listened to this month was “Master of Me” by Keke Palmer. I think Keke has such an energetic and joyous 
    personality. She often appears on my TikTok FYP, doing interviews for her various projects, and I never skip a video. I feel that 
    her energy is infectious, and when I realized she had written a book (she has multiple), I had to look it up. I was happy to find 
    that she read her own work, and that I could listen from my Spotify account. In “Master of Me: The Secret to Controlling Your 
    Narrative”, Keke walks us through her journey in realizing her true value in work and life. She shares the same values I do when 
    it comes to the belief that we all have the capability to take our lives into our own hands and continuously elevate our own 
    value and worth. She talks about treating oneself like a business and knowing when it's time to rebrand oneself. These are all 
    themes relevant to me and where I am in my journey as I continue to go through my career transformation.

    Finally, to close out the month of March, I finished reading “Harry Potter and the Prisoner of Azkaban”. As mentioned earlier 
    this year, I'm reading through the entire Harry Potter series for the first time. I've loved discovering details I never noticed 
    in the films—from the intricacies of Hogwarts castle to the nuanced personalities of the wizards. This third book in particular 
    impressed me with its darker tone and the brilliant way it handles time travel in the final scenes. The introduction of 
    characters like Sirius Black and Professor Lupin adds depth to Harry's connection with his parents' past. I follow up my reading 
    with the movie every time I've finished a book, which has made for an illuminating comparison between the source material and its 
    adaptation. The film certainly captures the atmosphere well, but I'm finding that the books offer a richness of detail and 
    character development that simply can't be condensed into a two-hour movie.

    This was surely an exciting month for reading, filled with diverse genres from romance to science fiction and memoir. 
    Each book offered me a unique perspective—whether viewing Earth from space, time-traveling for love, or learning to value myself 
    like Keke Palmer does. I've already begun my April reading journey with “Cleopatra and Frankenstein” by Coco Mellors, which 
    promises to be another fascinating exploration of relationships and personal growth. I'm looking forward to sharing my thoughts 
    in my next post!

    —April 19, 2025: From Complicated Love and Hustle Culture to Inner Peace—

    [Some thoughts on: "Cleopatra and Frankenstein", "Don't Believe Everything You Think", and "How to Stop Trying"]

    Earlier this month, I finished reading "Cleopatra and Frankenstein" by Coco Mellors. I really wanted to love this book before I 
    even began reading it—I'd seen people compare it to Sally Rooney books, which I really enjoy. The story mainly follows two 
    characters, Cleo and Frank, from the moment they first meet in New York City, and shows us how their story intertwines with the 
    lives of those around them. Cleo and Frank get married six months after meeting, there is a considerable age gap between them, 
    and they are both grappling with their own personal issues (trigger warning: this book discusses topics of addiction and 
    self-harm). We hear about the lives of their closest friends—everyone is going through something—and even the perspectives 
    these friends have on Cleo and Frank's unlikely and complicated relationship.

    I typically like books with various complicated characters, but I never liked any of the characters in this book. I don't think 
    we're supposed to like them, anyway; they're all flawed and make questionable and unhealthy choices that make you want to look 
    away. In spite of this, there also wasn't any focused plot to follow along. The book is made up of snippets of these characters' 
    lives, moments in time, that show them at their worst. We get a very brief glimpse of what's in store for these characters' 
    futures in the very last few pages of the book. I love books with character development, but I wasn't given enough time to 
    see these characters at their best or revelatory phases. Regardless, if you enjoy reading books with complicated characters 
    where you are also exposed to those various points of view then I'd recommend checking this book out.

    I've also been really into self-help books this month. I listened to the audiobook for "Don't Believe Everything You Think: Why 
    Your Thinking Is The Beginning & End Of Suffering" by Joseph Nguyen, and I read "How to Stop Trying: An Overachiever's Guide to 
    Self-Acceptance, Letting Go, and Other Impossible Things" by Kate Williams. I wasn't planning to read “How to Stop Trying”, but 
    it caught my eye at my local library since I'd already started listening to “Don't Believe Everything You Think” and the themes 
    seemed aligned at first-glance.

    Listening to "Don't Believe Everything You Think" was very calming and meditative. Nguyen speaks about achieving peace of mind, 
    in many respects, by stopping our tendency to overthink and instead looking inwards and trusting our intuition. There were many 
    perspectives that resonated with me or made me think deeper. He says, "Your intuition is the tinge of fear that requires you to 
    step into the unknown and create a new reality rather than stay in your familiar one. Nothing that grows can stay the same, 
    especially you."

    I look back and think about the time in my life where I was deciding whether or not to quit my job to pursue a new career. I was 
    scared to leave a job that I was good at and that provided financial stability, but the job was taking a toll on my health and 
    also not giving me room to grow professionally no matter how hard I worked. Ultimately, I decided to go with the choice that I 
    knew would allow me to grow. I decided to invest in myself and planted a seed for my future, not knowing fully what the path to 
    creating a new reality would entail. The clarity of my intuition at that time propelled me forward with a choice I do not regret, 
    despite the many moments of doubt that followed.

    In "How to Stop Trying," similar to Nguyen's approach, Williams discusses the tendencies of individuals who are overthinkers, 
    overachievers, and who don't know when to stop trying. While Nguyen's book is broadly geared toward anyone looking to overcome 
    anxiety and end personal suffering, Williams shares her experience from the perspective of a woman and mother on learning how to 
    let go in this day and age of intense hustle culture. She says, "Much like there will be times in your life when quitting isn't 
    an option and you have to hang in there, there will also be times in your life when you are not able to choose what you sacrifice. 
    There will be plenty of times when forces outside of your control require you to push through pain and suffering. So why not save 
    the pain and suffering for those times? You're not on this planet to play a supporting role in your own life. Your emotional and 
    physical well-being should not be collateral damage. You're not obligated to obliterate yourself for anyone."

    I felt validated hearing this perspective because in my career, I've had to make the decision to end my own suffering for my 
    well-being rather than stick around for the company I was working for. I was lucky to have had the opportunity to work hard and 
    then find myself in the position to pivot.

    Another quote from Williams that resonated with me is around the concept of "self-care." She says, "We have also bought whole-hog 
    into the idea that self-care is not so much a necessity as it is a 'treat' or a 'reward.' ... We have to wrench the idea of 
    self-care away from luxury marketers and instead start treating it as what it really is: something that cannot be bought. True 
    self-care is making sure your basic needs (sleep, food, movement) are met on a daily basis. Self-care is setting boundaries, 
    even when they make people uncomfortable, so that you are not doing more than you can sustain."

    I love that she's calling this out because we live in a society that too often makes us feel bad for needing to take time off to 
    fulfill our basic needs, rest, or (god forbid!) take a vacation. I think that a company that makes a big deal about giving you 
    time off for a self-care day needs to re-evaluate why they feel they need to provide this for their employees in the first 
    place—because I bet those same employees feel like they can't fulfill their basic needs in their 9-to-5.

    Both of these self-help books have made me more introspective. I'm reminded that I'm constantly learning to trust my intuition, 
    set meaningful boundaries, and prioritize my well-being—and not as an afterthought. Next up on my reading list, I'm looking to 
    get back into some more fiction picks!

    —May 15, 2025: When the Drumming Monkey Went Silent - On Hearing Loss and Jellyfish Have No Ears—

    I keep telling myself I have to write down my thoughts immediately after reading a book, so that I don't have so much to recap at 
    a time in my reading blog entries. Despite telling myself this, I have not been successful in making this happen! After the 
    self-help books I read at the beginning of April, I was eager to get back to reading fiction. While picking up my library hold on 
    “Verity” by Colleen Hoover, a slender book named “Jellyfish Have No Ears” caught my eye on the display the library staff curates 
    at the front of the library. For this blog post, I'm focused on sharing more about one of these books.

    “Jellyfish Have No Ears” by Adèle Rosenfeld, a book translated from French, follows the story of a woman that has been partially 
    deaf most of her life and now faces a decision that requires a great deal of deliberation. Louise's hearing is rapidly declining, 
    and she must decide whether or not to get a cochlear implant. Growing up, Louise has never felt a part of either the fully hearing 
    or deaf community. She's always been somewhere in between. Now, as an adult, there's no denying that her hearing loss is continuing 
    to decline to the point that it's affecting her relationships with the people around her, work, and her sanity.

    In this book, the reader gets an accurate portrayal of what hearing and observation is like for a person that is hard-of-hearing. 
    This book caught my attention because I am partially deaf, so I can vouch for the numerous vivid descriptions of sound and 
    sensations that Louise experiences. For me, my hearing impairment is single-sided, and it was progressive loss at an early age 
    that left me partially deaf. I was four years old in Kindergarten when the school nurse discovered my hearing loss. It only got 
    progressively worse over the years. I went through various exams and utilized a series of equipment and hearing aids until 
    sometime in high school when it was deemed that the hearing in my left ear was essentially gone. Growing up like this, I learned 
    to adapt over time and eventually relied fully on hearing through my right ear.

    Honestly, I can't remember what it was like to have any hearing in my left ear at all. My single-sided deafness has always been 
    my norm, and although I have run into some challenging situations, I have not experienced what Louise experiences in this book.

    Although there are many descriptions of what being hard-of-hearing can feel like, this one description that Louise shares as she 
    contemplates getting the implant resonated with me. She says, “The operation, however, was irreversible: the 'natural' hearing I 
    currently had would be lost. The few cilia remaining deep in my ear caught high pitches and a few low ones, which barely allowed 
    me to reconstruct the meaning of what I heard. What I really got was a sense of the warmth of timbres, this soft sheen of wind, 
    of color, of all sound's snags and snarls.” I have a vivid memory of the audiology appointment I had as a kid where the doctor 
    explained to my mother and I how the “hearing” I had left was not enough for my brain to reconstruct what I had heard.

    I'll never forget those audiology line graphs, the audiograms, that showed that declining line deepening every visit. I'll 
    especially never forget that audiometric booth that I was subjected to for testing on numerous occasions. The booth had a 
    colorful mechanical stuffed monkey mounted in the top corner. The monkey would hauntingly play the drums once the exam was over. 
    It would taunt me at the end of every exam, supposedly banging the drums as an act of celebration. One day it no longer played 
    the drums at the end of the exam—a symbol of my lost hearing.

    I also deeply resonate with what Louise frets about losing her "natural" hearing as a result of going through with the implant. 
    For all of grade school, I wore one hearing aid, and eventually it didn't help at all. My “bad” ear couldn't reconstruct the 
    sound it was picking up through my hearing aid. The last pair of equipment I ever used was in college. I switched to wearing two 
    tiny hearing aids. One was worn on my “bad” ear, and the other on my “good” ear. This pair of hearing aids would allow the sound 
    picked up from the “bad” ear to be sent to the “good” ear. I never adapted to this, it didn't feel right, it felt like all the 
    sound coming into my “good” ear was through a telephone call.

    Sound that we receive through technology is simply different from the sound our ears pick up directly from another person. I 
    decided that being able to hear normally through my “good” ear was good enough for me. Like I said, I can't even remember what 
    it ever was like to have two perfectly hearing ears. I fully rely on my “good” ear, body movement, and spatial positioning to 
    ensure I've optimized my situation for hearing everything and everyone around me.

    I sincerely cannot think of any other book I've ever read where there is a partially deaf character, or a character with any sort 
    of hearing impairment. In grade school, I only knew of two other girls in my grade with a hearing impairment. Unfortunately, that 
    didn't make us automatic friends. If anything, I'm sure we all had the same idea of trying to fit in with the rest of the kids as 
    best as we could. When I was younger, there were times that my hearing loss affected my confidence. Larger rooms with more kids, 
    a presentation, networking for events, that all felt overwhelming and intimidating at times.

    Louise expresses how her loss made her feel; she says: “Orphaned. Yes, that was very much how I'd always felt, this sensation of 
    not belonging to any community. Not deaf enough to be a part of Deaf culture, not hearing enough to be fully within the hearing 
    world. It all came down to what I'd convinced myself to be or not be. The collateral damage that had chipped away at my self-worth 
    and my confidence were, for those soldiers, orphaned issues that they struggled to make sense of.” I can understand where Louise 
    is coming from, not always feeling fully a part of the hearing world—as time passes and as I've grown up, I've felt less of that, 
    but I can fully agree that a lot of it comes down to what we convince ourselves to be.

    My hearing loss used to be my greatest weakness growing up, but I'm grateful for the strengths I've developed as a result of my 
    condition. I will always attribute my strength of being a fantastic listener to how I was forced to exist and adapt to every 
    hearing situation I've encountered from a very early age—I'm a natural active listener. And, I'm extremely empathetic—it's hard 
    not to be, especially when you're sensing and feeling so much from within to make up for the sound that can't be processed.

    I highly recommend picking up this quick but deeply fascinating read. Rosenfeld has crafted a story that authentically captures 
    the nuances of navigating life with hearing loss. The book offers a window into an experience that's rarely represented in 
    literature, making visible what is often invisible. Everyone can benefit from understanding what it feels like to live with an 
    invisible disability, whether or not you actually have a hearing impairment. For me, finding Louise's story felt like discovering 
    a reflection of part of my own experience on the page—a rare and valuable thing indeed.

    —May 19, 2025: The Stranger at La Pecora Bianca Was Right - I Finally Read Verity—

    To round out April, I read "Verity" by Colleen Hoover. I read "It Ends with Us" years ago (I haven't watched the movie), and almost 
    didn't pick up another Hoover book after learning about some author controversies—I've been conflicted about whether or not to 
    read another book by her. However, multiple friends have talked about "Verity" and have urged me to read it. I'm not kidding! 
    I was even having dinner one time at La Pecora Bianca in SoHo with a friend who was telling me all about this book, when all of a 
    sudden, a woman next to us who was clearly on a date abruptly interrupted us (and her date) to back up my friend and try to 
    convince me to read this book. Apparently, that's how good it was. I've always thought about that interaction, but I was standing 
    firm about not reading it—that is until I heard who was cast to star in the upcoming movie adaptation (Anne Hathaway, Dakota 
    Johnson, and more).

    Finally, I've gotten around to reading this book—in three days (and no more)! It has been my quickest read of the year. This 
    thriller mainly follows Lowen, a struggling writer who takes on a job to be a ghostwriter for well-known author Verity Crawford. 
    Verity is unable to finish her book series due to an injury, so Lowen relocates to the Crawfords' home, where Verity worked, to 
    accomplish the ghostwriting job. It doesn't take long for Lowen to realize some things about this family aren't adding up. She 
    starts to uncover disturbing information through an autobiography that Verity has hidden away, one she's sure no one else has seen.

    This book was an absolute page-turner, I won't deny it. There were twists and turns that I didn't see coming. This thriller is 
    packed with themes of obsession, grief, and loss. If you're looking for a book to get back into reading that is enticing and 
    mysterious, then I'd surely recommend this one.

    —May 28, 2025: A Pandemic Déjà Vu - Why Ling Ma's Severance Felt Like Reliving 2020—

    I started the month of May by reading “Severance” by Ling Ma. This book has long been sitting on my TBR shelf. I have friends who 
    have read it, and it's a book that received widespread acclaim. However, with the lack of blurb on the paperback's back cover, 
    and outstanding reviews listed instead of a typical summary, I was largely mistaken about the book's plot. Because of its title, 
    I assumed it had to do with an individual getting fired from work and getting a severance package, but I was wrong—kind of. I was 
    satisfied to discover that this book explores many themes including workplace culture, capitalism, immigrant upbringing, and grief.

    This story is set in a post-apocalyptic period and follows Candace, a NYC transplant, who was working in Bible production at a 
    publishing company. She becomes nomadic after “Shen Fever”, a fungal infection, wipes out the vast majority of the earth's 
    population. I recall living and working in NYC at an event marketing company when COVID-19 hit in 2020. Like most people at the 
    time, I spent every day weighing whether or not to leave the city, and eventually I did—but I also was one of the first to come 
    back. During this period, I kept working my full-time job despite the pandemic happening around me. Candace does the same for as 
    long as she can.

    Eventually, her survival depends on joining a group of survivors who are traveling toward "The Facility," a supposed sanctuary 
    that their leader is guiding them to in order to restart their lives.

    Those that are affected and become fevered are essentially zombie-like; they lose consciousness, and are stuck in a loop of 
    memories and repetitions. I thought I'd be reading about the type of zombies that appear in movies such as “I Am Legend” or even 
    “Zombieland”. The deserted cities in those movies are really the only scenes that I could grab from to compare when reading this 
    book. The fevered in this book are not harmful in the way we may typically think that zombies are dangerous. They're contagious 
    without being violent. Memories and nostalgia are the true enemy in “Severance”.

    During this journey, readers gain insight into both Candace's present nomadic state and her pre-apocalypse life. We learn about 
    her Chinese-American immigrant upbringing, her parents' journey starting a new life in America, and the cultural connections 
    between NYC's Chinatown and her family's origins in China. 

    I was particularly fascinated by her overseas work experience traveling to China where her publishing company has a manufacturing 
    outpost. We also learn about Candace's career progression in NYC, as well as her experience navigating the friendships and power 
    struggles in the workplace and later among the group of survivors she's bound to. 

    As a reader based in NYC, I enjoyed hearing her perspective on work culture in the city and her insight on the different 
    neighborhoods that make up this great city. It's amazing to realize that she is one of the last remaining survivors in NYC 
    before she joins the group given the city's vast size. The fact that she continues to work long after the fever hits and many 
    people have left the city, and that those that stayed have mostly become fevered, may give us some insight into why the book is 
    titled “Severance” to begin with.

    What risks are we willing to take in order to show up in-office? What is the true value of the severance being offered in this 
    day and age? These are the questions that I pondered when I realized that Candace continues to work for so long because she feels 
    bound to a contract that is paying her to continue to show up in-office while an infection is spreading worldwide. Does she 
    benefit from this at all? No spoilers here, so you'll have to read the book to find out.

    In addition to having a fascinating storyline, I thoroughly enjoyed the writing in this book; passages, such as: “A day off meant 
    we could do things we'd always meant to do. Like go to the Botanical Garden, the Frick Collection, or something. Read some fiction. 
    Leisure, the problem with the modern condition was the dearth of leisure. And finally, it took a force of nature to interrupt our 
    routines. We just wanted to hit the reset button. We just wanted to feel flush with time to do things of no quantifiable value, 
    our hopeful side pursuits like writing or drawing or something, something other than what we did for money.” The author's 
    examination of seemingly mundane concepts like a day off reveals deeper insights about modern culture. I valued the book's 
    descriptive language, satirical commentary, and the prose that definitely captured my attention.

    Overall, I found it unnerving that this book was first published in 2018 and we experienced our own pandemic in 2020. Initially, 
    I wondered if this book was written in response to our recent pandemic, but I was surprised to discover it was published two years 
    before COVID-19 hit. I found myself entranced by this book, reading it in 2025, and having nightmares—I cannot imagine reading 
    this during the actual pandemic. This book, although considered a dystopian sci-fi novel, has the type of  introspective story 
    that I enjoy reading most. I'm glad to have this book in my collection, and I definitely recommend picking it up if you're looking 
    for a darker satirical read.

    —May 31, 2025: On Grief, Friendship, and the Weight of the Past - A Review of Oh William!—

    I love discovering new titles and new authors, but it's always fun when one book leads you to discover another. For me, this 
    month, I chose to pick up another book from an author that I discovered last year. That author is Elizabeth Strout, whose novel 
    “Oh William!” caught my attention. Last year, I found “Lucy by the Sea” by the same author at my local library and I enjoyed it 
    more than I thought I would. Imagine my surprise when I discovered that “Lucy by the Sea” and “Oh William!” feature the exact 
    same characters!

    Once I got home after picking up “Oh William!” I did further research and found that there was an entire set of books devoted to 
    these characters. While these books can be read independently, discovering there's an entire series made me even more excited to 
    dive deeper into these characters' lives.

    These books center on Lucy Barton, and she's such an endearing character that I was immediately drawn to reading more of Strout's
    work. She captivated me as a character—she's a sixty-something writer and mother living in New York City, originally from 
    Illinois, whose authentic voice and complex relationships feel remarkably real.

    In this book, Lucy is grappling with the recent death of her second husband. She's working through her grief and in need of 
    human connection, just as her first husband finds himself equally in need of human connection. William is Lucy's ex-husband 
    and the father of her children—now adult daughters. Throughout the book, we learn about Lucy and William's relationship. Their 
    pasts together and apart are so indicative of the people they have become. From lovers to friends, we get an inside look at 
    everything that's happened in order to get to this point. Their unexpected adventure reveals how people can evolve while the 
    weight of shared history remains unchanged.

    Strout's prose captures emotional truth with startling precision. Lucy, being a writer, reflects on the moment she realizes she 
    became a more earnest writer. Shortly after making the decision to leave William, she reflects, “A tulip stem inside me snapped. 
    This is what I felt. It has stayed snapped, it never grew back. I began to write more truthfully after that.” Love can be so 
    fragile and Lucy portrays it through this tulip metaphor. Her love for William was so grand at one point in time, it caused her 
    physical pain, and the outcome made her more honest with herself.

    White tulips prove to be a recurring symbol in this book. We also learn how important it was to Lucy that her second husband 
    always made sure to give her tulips, they were always in her home, and they even grace the cover of the book. They are Lucy's 
    favorite flower, but they are also so powerful in showing us how love transforms but endures in different forms.

    There is no shortage of moments where a reader can witness the growth of these characters, and that's exactly why I'll continue 
    to work my way through the Lucy Barton series. I recommend diving into this series if you enjoy character-driven stories about 
    complex relationships.

    —June 20, 2025: On Invisible Illness, Caretaking, and the Healing Power of Books - My May Reads—

    [Some thoughts on: "There's Nothing Wrong with Her", "Fake It Like You Mean It", and "More Days at the Morisaki Bookshop"]

    Welcome to my May reading recap—where I'm finally finishing up the last of my May reads! I have to admit, I'm being a bit 
    sarcastic here because May turned out to be my biggest reading month yet, and here we are well into June with me still 
    catching up on blog posts (so much for my promise to stay more current!). I managed to get through five books total, including 
    the two I already covered in my previous posts. Today I'm sharing thoughts on the final three: "There's Nothing Wrong with Her" 
    by Kate Weinberg, "Fake It Like You Mean It" by Megan Murphy, and "More Days at the Morisaki Bookshop" by Satoshi Yagisawa. 
    Let's dive in!

    I picked up "There's Nothing Wrong with Her" at my local library and I was intrigued by the book cover—the woman lying in what 
    appears to be a human-sized fishbowl with her goldfish, her legs sticking straight up as if she's underwater with her pet, all 
    resting on colorful aquarium pebbles against a bright blue background. There are also quotes from Sarah Jessica Parker and 
    Kiley Reid on the cover. I've read "Such a Fun Age" by Reid and remember it to this day, and well, SJP is just a downright 
    icon in television, fashion, and is known for being a voracious reader.

    The book follows Vita, a woman with a seemingly incurable illness, who sometimes finds herself in "The Pit" during moments 
    where she no longer feels in control of her body or mind. She has her goldfish, Whitney Houston, to accompany her every day 
    that she spends in the apartment she shares with her doctor boyfriend, along with the neighbors that inhabit her building. 
    This is a story that explores themes of love, identity, grief, and mental health.

    The theme of mental health impacted me the most, as Vita so vividly describes the feelings that overcome her when she finds 
    herself in "The Pit". She says, “I'm back down here, a feeling of extreme weakness like I might dis a p p e a r. Every cell 
    is squeezed dry leaving just a frail web of nerves, the skeleton of a leaf. An itch on my nose. No energy to lift my hand. 
    Hard to distinguish weakness from lack of signals from the brain.” I've rarely read such a detailed and almost poetic 
    description of these feelings of despair and loss. It was fascinating to see how the author found an almost beautiful way to 
    articulate these experiences.

    It's hard to accept that the people around Vita doubt that there is anything wrong with her when she's processing her past and 
    present relationships while living through so many emotions. This makes me wonder about the available diagnoses and treatments 
    in Western medicine, and the lack of modern tools and solutions that support mental health. From exploring the complexity of 
    invisible illness, I moved on to “Fake It Like You Mean It,” which tackles health challenges from a completely different 
    angle—through the lens of Alzheimer's and unexpected romance.

    My sister urged me to read "Fake It Like You Mean It" after reading it with her book club. I haven't read many romance novels 
    this year and was looking forward to a lighter read, but I found that while this book has a fake dating trope and light comedic 
    moments, it also explores complex relationships and caretaking.

    In this book, Elle leaves behind her Chicago city life and puts her podcast career on pause to take care of her grandmother, 
    Lovie, as her Alzheimer's diagnosis worsens. Lovie raised Elle, and now the roles are reversed. To her surprise, Elle finds 
    that there's now a live-in nurse, Adam, who has taken over Lovie's routine and care. It doesn't take long for tensions to rise 
    around how to best care for Lovie, and to top it all off, she's convinced that Elle and Adam are lovers.

    However, it was the plot around Elle's responsibility to her grandmother—to take care of her through her Alzheimer's 
    diagnosis—that tugged at my heart the most. I learned so much about Alzheimer's, and I think this story shows why caretakers 
    are so essential, whether they're family  members or healthcare professionals. Elle is fortunate enough to have a career that 
    grants her the flexibility to show up for others in their time of need, and that makes me reflect more deeply on the flexibility I 
    desire in my own career.

    For my final May read, I returned to familiar territory with “More Days at the Morisaki Bookshop,” the sequel to a book I fell 
    in love with last year. The books are set in Jimbocho, a district in Tokyo known for its many bookshops, and mainly center 
    around Takako, a young woman who has frequented her favorite secondhand bookshop ever since reconnecting with her 
    uncle, Satoru, in the first book. The Morisaki Bookshop has been in their family for generations, and it's heartwarming to see 
    how it plays a role in their lives. Now, despite difficult times, they must remember why they love it so much in the first 
    place in order to keep it from shuttering.

    In this new story, we meet many of the same familiar friends from the first book—uncle Satoru and his wife, Momoku, and 
    Takako's friends Tomo and Takano. Through them, we learn about the beauty of friendships and their many phases throughout time. 
    However, my favorite thing about these books is how much love all these characters have for books. Tomo says, “When I'm sad, I 
    read. I can go on reading for hours. Reading quiets the turmoil I feel inside and brings me peace. Because when I'm immersed in 
    the world of a book, no one can get hurt.” She expresses so clearly how books provide comfort and escape. For me, reading can 
    be so meditative and is always a welcome distraction from the real world.

    There's something so cozy about the world that Takako and Satoru are so attracted to. If the Morisaki Bookshop were a person, 
    then they'd all be related by blood. They fit so well within it that it's no wonder others are drawn to it despite its humble 
    nature as a secondhand bookshop.

    Looking ahead to my June reading, I've just finished reading “Wellness” by Nathan Hill. It was a very hefty, lengthy book, 
    probably the thickest book I've read this year. And while it took me about twenty days to read, I need some more time to gather 
    my thoughts. Look out for my next update to learn more about what I thought about it!

    —August 4, 2025: More Than Just a Health Fad - A Review of Wellness—

    I've put off writing down my thoughts on “Wellness” by Nathan Hill because the task felt overwhelmingly daunting! Not 
    because I have negative things to share, but because this enormous book covers so many topics across a lengthy, intricate 
    storyline. I kept thinking to myself: “Where do I even begin with this book?”. Then, I realized I don't have to cover it all. 
    I can write about whatever I want—and that's exactly what I'll do here. 

    To start, I learned about this book from an online influencer and was motivated to pick it up when I heard that one of its main 
    themes is a questioning of modern wellness culture. I found that rather intriguing because we live in an age where “wellness” 
    culture is thrown at us from every direction. Topics like manifestation and the placebo effect are explored, and at times, even 
    mocked. Beyond wellness, the book also delves into the complexities of technology, the struggles of parenthood and marriage, and 
    the profound ways family history shapes us as individuals.

    I absolutely loved the book's opening, which tells the beautifully descriptive story of how our two main characters, Jack and 
    Elizabeth, meet and fall in love in 1993 Chicago. In fact, Hill's talent for painting scenes with words is a highlight 
    throughout the entire novel. He does not disappoint when it comes to describing people, places, or things. For example, 
    describing a Wicker Park night from Jack's point of view: “He loves the noise of the city because there's something reassuring 
    about it—the evidence of other people, neighbors, compatriots. And also there's something grand about becoming insusceptible to 
    the noise, sleeping peacefully through the urban night without flinching at the beeps and voices and car alarms and police sirens 
    outside—it's an important marker of transcendence.” Whether detailing a feeling, a setting, or even a famous painting like Grant 
    Wood's “American Gothic”, I always felt fully immersed, visualizing exactly what I think Hill intended.

    The story introduces us to Jack and Elizabeth as young, free-spirited college students. Fast forward twenty years, and they are 
    married parents to their eight-year-old son, Toby, planning a move to a new suburban condo development called the Shipworks. 
    These are condos that “have it all”, and Jack and Elizabeth are customizing their unit to the max, hoping to create their 
    “forever home”.

    The contrast between their past and present selves is stark. Jack is now an adjunct art professor teaching classes at the 
    university, and Elizabeth works at an institute called, fittingly, Wellness. They have done well for themselves. Back in their 
    student days, they could be found “culture-jamming” with friends—pulling pranks at a retail mall as “a way to resist [the] 
    homogenizing, Earth-destroying corporate capitalist machine, but with a sense of humor.” They believed the system and those 
    complicit in it were “plainly immoral”, which justified their antics. Now, on the verge of moving into a luxury condo, Elizabeth 
    reflects on their youthful arrogance, realizing they were naive idealists who would eventually have to join the very economy they 
    once scorned in order to build a life. Elizabeth realizes that, like her friends who had already had children and moved on from 
    the city, it's okay for people to change their minds on what they want in life or how to raise a family.

    Throughout the novel, we move between the characters' past and present, even delving into the lives of their ancestors. Jack grew 
    up in the rural Flint Hills of Kansas, where life was quiet and leaving for the city was a big deal. Elizabeth, by contrast, grew 
    up in an affluent family that moved frequently, placing high expectations on her. These histories play a crucial role in how they 
    navigate the world and make choices for their family today. Both had difficult childhoods, and their pasts heavily influence 
    their parenting as they strive to do better by Toby.

    It's particularly interesting to see how technology shapes the family's life. Toby is socially awkward but thrives in the online 
    worlds of Minecraft and gaming streams, an obsession that enthralls him and baffles his parents. Technology's impact is also 
    felt by Jack, whose job security is threatened by university metrics judging his value as a professor, and whose relationship 
    with his father is strained by the Facebook algorithm on top of their already complicated history. His dad becomes susceptible 
    to online misinformation, creating a rift that Jack struggles to bridge.

    Overall, I found “Wellness” to be a brilliant book, chock-full of timely topics and amazing storytelling. From youthful optimism 
    to the ever-changing dynamics of a family growing up, I think readers will walk away feeling like they've learned something, with 
    a gentle nudge to reconsider how they are living their own lives in this modern world. I certainly finished it thinking about my 
    own future and the choices I once thought were set in stone.

    —August 5, 2025: Not Your Average Beach Read - My Thoughts on Just for the Summer—

    To kick off the summertime, I wanted to dive into some beach reads! A book that's been on my reading list for a while now is 
    “Just for the Summer” by Abby Jimenez, and with summer underway, it felt like the perfect time to finally pick it up. I borrowed 
    my copy from my sister (@fromthelibraryofana on Instagram!) and was super excited to jump in!

    The book features the popular “fake dating” trope and follows Emma and Justin, who connect—of all places—on a Reddit thread. 
    They're both convinced they're cursed: every person they've ever dated has found their soulmate immediately after breaking up with 
    them. Their plan? Date each other and break up, theoretically launching them both into the arms of their future soulmates. After 
    agreeing on a set of dating rules for their temporary relationship, their experiment begins.

    However, their personalities present an immediate challenge. Emma is a free-spirited traveling nurse with no permanent home, 
    though she's secretly hoping to fall in love someday. Justin is a family-oriented engineer who is ready to settle down. As they 
    navigate their fake relationship, their fundamental differences in values and life goals become a central source of tension. The 
    narrative is also enriched by a cast of compelling side characters, including Emma's best friend, her on-the-go mother, and 
    Justin's close-knit family, all of whom play vital roles in shaping the couple's journey.

    I went into this book expecting a light, romantic read, but it wasn't exactly that. Instead, it thoughtfully explored heavier 
    topics like depression, mental health struggles, and toxic family dynamics. I thoroughly appreciated the author's content warning 
    at the beginning of the book, which prepared me for the emotional depth to come.

    Overall, I found this to be a much richer and more complex book than I initially expected. While I went in thinking it would be a 
    light beach read, the depth of the storytelling—particularly around Emma's character and her past—made it far more engaging than 
    your typical lighthearted romance. The heavier topics added layers that made me more invested in the characters' journeys. I was 
    especially satisfied with how Emma's story arc resolves, and I found myself genuinely rooting for her growth and happiness. 
    Without giving anything away, I'll just say that her journey of self-discovery felt genuine and earned.

    If you're looking for a romance with real depth and emotional weight alongside the romantic tension, then I definitely recommend 
    this one. Despite tackling heavier themes, it still kept me turning the pages and never felt overwhelming. It's much more 
    substantial than the typical beach read—which, in my opinion, made it even better!

    —September 24, 2025: Summer Reading Extravaganza, Part 1 - Beach Reads and Breakthroughs—

    [Some thoughts on: “One Golden Summer”, “That Summer”, “All the Lovers in the Night”, and “The Let Them Theory”]

    Welcome to Part 1 of 2 of my summer reading extravaganza series where I catch you up on all the books I read this summer! I love 
    reading books all year round, but there's something about picking up some romantic or mysterious beach reads on a sunny day that 
    set the perfect tone for a hot day at the beach. “One Golden Summer” by Carley Fortune and “That Summer” by Jennifer Weiner were 
    my quintessential beach read picks this year. And while I love some classic beach reads, I also got to read some books that have 
    caught my eye recently, including “All the Lovers in the Night” by Mieko Kawakami and “The Let Them Theory” by Mel Robbins. This 
    lineup of traditional summer reads and stories on personal growth was a perfect mix.

    Last year, I read Carley Fortune's “Meet Me at the Lake” and “This Summer Will Be Different”, and the year prior I read “Every 
    Summer After”, so I was so excited to dive into “One Golden Summer” this year. The worlds that Fortune creates for the characters 
    of her books are so magical and instantly transport me to the shores of Kamaniskeg Lake in Barry's Bay of Ontario, Canada. I've 
    never been, but I can imagine living out a perfect summer in this setting. This book follows Alice Everly, a 33-year-old 
    photographer from the city of Toronto, to Barry's Bay where she spent a single summer as a teen. She chooses to return to spend 
    her summer here as she takes on the responsibility of taking care of her grandmother who is recovering from hip surgery. It's here 
    that she collides with Charlie Florek, the boy (now man) she unknowingly captured in her most revered photograph taken as a teen 
    when she first spent a summer at Barry's Bay. It's the photo he's in that ultimately got her into her career in the first place. 
    Alice spends the summer getting back her passion for photography, reconnecting with her grandmother, and unexpectedly forming a 
    new friendship. I would be remiss not to mention that I loved hearing more of Charlie's story and seeing his personality shine in 
    this book (he is a secondary character in “Every Summer After”). This book was an escape to a summer on the lake and gives readers 
    a look into the complicated but heartwarming experience of chasing nostalgia, finding oneself, and giving love a second chance.

    While “One Golden Summer” was the perfect escape into lakeside romance, my next beach read, “That Summer” by Jennifer Weiner, took 
    a more mysterious and complex turn. Beyond its mystery-like plot, this book explored serious topics such as the #MeToo movement, 
    trauma, and revenge. This story follows two women, Daisy and Diana, who meet due to misdirected emails when their email addresses 
    are slight variations of each other's. As a reader, we get to see the perspective of each of these women in a back-and-forth as we 
    learn about their pasts and also the kindling of their friendship over this unexpected mix-up. Very quickly we learn about the 
    stark contrast in their lives—in their family life, professions, and their pasts. On top of the obvious differences in their lives, 
    as time goes on, a web of secrets unravels as we learn more and more about each of their pasts. I'd recommend this book to anyone 
    looking for a page-turning “beach read” that is also a mystery with intrigue and a story about friendship—all taking place on the 
    Cape.

    Moving from a story of interconnected secrets on the Cape, you'll find a shorter, solitary, but highly introspective read in Mieko 
    Kawakami's “All the Lovers in the Night”. I was drawn to this book because the staff recommendation card at McNally Jackson Books said 
    that this was “for people who cry on their birthday”. I laughed when I saw that because I am actually the type to get emotional on 
    my birthday—it's a super reflective time for me. Ultimately, this book did make me reflect heavily. At a glance, it would seem that 
    Fuyuko, our heroine, is simply figuring life out in bustling Tokyo, Japan. She's grappling with her career as a proofreader, 
    interested in learning new things, and putting herself in a vulnerable position when meeting new people and building relationships. 
    The writing demonstrates the profound aspects and realities of living with a great sense of loneliness in a very loud world. In 
    some ways, this book felt like a quick read and in other ways it felt heavy and left me pondering the realities women experience 
    in this world.

    That feeling of deep reflection carried right into my next read, Mel Robbins's “The Let Them Theory”, which offered a more direct 
    approach to navigating life's challenges. I've listened to some of Mel Robbins' podcast episodes and her newest title intrigued me. 
    This book teaches how to take control of your life and stop letting the actions and opinions of others impact you negatively. 
    Through a series of stories from Mel's own life journey, she proves how a simple change in your mindset (from “let them” to 
    “let me”) can transform your life. It was a good reminder on how to protect your peace and how to focus on your own personal 
    journey.

    Whether it was escaping to a lakeside summer, unraveling a seaside mystery, navigating loneliness in a bustling city, or learning 
    to protect my peace, all of these books touched on personal reflection and finding your way. They were the perfect companions for 
    these long summer days. Be sure to check back for Part 2, where I'll be discussing some of the more thrilling and at times darker 
    sides of my summer reading.

    —October 3, 2025: Summer Reading Extravaganza, Part 2 - Thrills, Power, and Wolves—

    [Some thoughts on: “Atmosphere: A Love Story”, “The Godfather”, and “A Woman Among Wolves”]

    Welcome back to part 2 of my summer reading extravaganza series where I catch you up on all the books I read this summer! I'll 
    cover some darker and thrilling summer reads filled with stories of power dynamics and survival. I'll share my thoughts on 
    “Atmosphere: A Love Story” by Taylor Jenkins Reid, “The Godfather” by Mario Puzo, and “A Woman Among Wolves” by Diane K. Boyd. 
    This reading blog post covers an unexpected range: a love story, a crime story, and even nature non-fiction.

    Back in June, I attended a very special book talk at Symphony Space in NYC in collaboration with Barnes & Noble Union Square for 
    Taylor Jenkins Reid's newest book: “Atmosphere: A Love Story”. I have loved reading some of her other works including “The Seven 
    Husbands of Evelyn Hugo” and “Daisy Jones & the Six”. I received my signed copy of the book at the event and had a chance to hear 
    her discuss this new book before even reading it myself. It was so cool to hear about the process behind writing it—especially 
    because there was a lot of research that went into writing a book that is partially set in outer space. 

    This story follows our heroine, Joan Goodwin, one of the few women who are selected for NASA's space shuttle program in the 1980s. 
    We learn about her unique experience training in the NASA program, and about how this monumental opportunity impacts her 
    relationships with her family, friends, and colleagues (and potentially love interests?) I felt impacted by the moments where 
    Joan and her female colleagues' actions and roles contributed to a larger discussion on the experience of women in STEM. Her 
    close relationship with her niece, Frances, is unique and truly exhibits her empathetic side—a quality required to be an astronaut. 
    To Frances, a little girl with dreams, Joan is a hero. She was also a kid with a big dream, and now she's turning that dream 
    into a reality. Joan remembers the wonder of space as a kid and she thinks about that often as an adult. Reid captures Joan's 
    profound sense of wonder: “Humans had gone to the moon. And sure, they were all Americans in that shuttle at that very moment. 
    But for the space shuttle program to be an American victory felt so small compared to the victory that it could be, should be. 
    Look what we humans had done. We had looked at the world around us—the dirt under our feet, the stars in the sky, the speed of 
    a feather falling from the top of a building—and we had taught ourselves to fly. It was as beautiful an achievement to Joan as 
    anything Rachmaninoff had written, as Leonardo da Vinci's Vitruvian Man, as monumental to her as the Great Wall of China or the 
    pyramids of Egypt. Space belonged to no one, but Earth belonged to all of them.” The way that Reid allows the reader to experience 
    space through Joan is dreamy and truly poetic. This heroine is thought-provoking, brave, and insightful. And all of these qualities 
    prove to be essential in the most thrilling space mission that Reid takes us on. If you're looking for an emotional read that gets 
    you in your feelings, then this is it. This story brought me to tears and I did not want to put it down even once I got to the last 
    page.

    From reading about Joan's journey to get to outer space, this next read brings us down to Earth and tells the story of the 
    power-hungry mafiosi of New York City in Mario Puzo's “The Godfather”. I've been meaning to read this book since I finished 
    watching the television drama series “The Sopranos”. And, I couldn't watch “The Godfather” movie until I read the book. What 
    can I say? I've been really into mob stories for the drama, thrill, and this idea of a lovable gangster that the reader or viewer 
    is surprisingly, at times, rooting for. This book follows the Corleone family, a coveted Mafia family in New York, as they 
    struggle for power amongst other prominent families in the Mafia. Things are thrown out of order when Don Corleone, the Godfather, 
    refuses to go into the drug business. This is a story about power struggles, crime, succession, and ultimately family. I enjoyed 
    the colorful descriptions of each member of the Corleone family and learning about the role that each member plays in trying to 
    restore the respect and prominence of the family as a result of a business deal gone bad. There were also scenes in the book that 
    made me wince—after all, this is a crime novel that does not shy away from describing violence and brutality so vividly. After 
    finishing this lengthy book, I followed up my reading with a screening of “The Godfather: Part 1”, and although I enjoyed watching 
    it, you'd be remiss to skip reading the book. There is so much you'd be missing, from the characters, to the plot, and the additional 
    side quests and storylines that the book delves into. I'm happy to say that I've finally read this “classic” and that I will 
    finally understand all “The Godfather” references ever made in pop culture (including all of the references made in my favorite 
    television series “Gilmore Girls”). While the Corleones fought for dominance in a concrete jungle, this other summer read explored 
    the dynamics of a very different kind of family struggling for survival in the wild: a wolf pack in Diane K. Boyd's “A Woman Among 
    Wolves”.

    I usually stick to reading fiction, aside from the occasional memoir or self-help book, but I'm so grateful to have uncovered 
    nature non-fiction as a genre I thoroughly enjoy reading. This summer, I started volunteering with the Riverside Park Conservancy, 
    and I also joined their seasonal book club. I've always wanted to learn how to garden, so in an effort to make more time to spend 
    outside and also learn something new, joining the volunteers at Riverside Park was a perfect match. However, it came as a 
    surprise to find that as a NYC-based organization, we'd be reading “A Woman Among Wolves” for the summer book club pick—only 
    because there are no wolves in NYC. I was doubtful I'd enjoy this book, at first, and was thoroughly surprised only a third of 
    the way into the book. This book is a compilation of Boyd's forty-year-long journey studying wolves in Montana. We hear about her 
    experiences as a pioneer in wolf research, management, and recovery. As for its relevance, and how it relates to nature, this book 
    undoubtedly covers animal research and conservation, wilderness survival, environmental regulations, the effect of the human 
    population, technological advancements in aid of animal protection, and more. I didn't realize how much I enjoyed learning about 
    nature until I read this book. On top of all of the new knowledge I gained, Boyd discusses the career challenges in this space as 
    it relates to being a woman and even more generally. She describes the fierce pushback that she and her colleagues were met with 
    at an event where many locals were campaigning for the reduction of wolf populations. She says, “The rhetoric I heard in Trout 
    Creek felt like something out of the Dark Ages. It was disturbing to realize that some things don't change, no matter how much 
    effort you put in. When there are firmly entrenched prejudices perpetuated in isolated communities, it's an uphill battle to get 
    anyone to see things differently, and after so many years of work, it's supremely frustrating to see that you're getting nowhere. 
    And yet, in the larger picture, wolves are winning their recovery battle.” I found Boyd's experience in Trout Creek, with trying 
    to educate locals about the biology of wolves, to be very emotional. Imagine trying to educate others about your life's work, 
    only for it to be contested by individuals who aren't willing to budge on their firmly ingrained beliefs and who want to 
    passionately reduce wolf populations. This book showed me just how thrilling and dramatic this important and real-world work 
    can be. Overall, this book sparked my interest in picking up more nature non-fiction books in the future.

    Despite having very different storylines, all three of these books explored power dynamics and survival in one way or another. 
    Whether it was through the high-pressure environment of NASA, the violent underworld of the Mafia, or the raw wilderness of 
    Montana—the characters in all of these books came across similar feelings and emotions when dealing with the environments that 
    surround them. That's all for my summer reading extravaganza catch-up! Stay tuned for some Fall book reviews, where I'll be 
    discussing the books I've already started crossing off my Fall TBR list.
`.trim().split('\n\n');

const bookList = [
    {
        title: 'The Christmas Fix',
        author: 'Lucy Score',
    },
    {
        title: 'The Hunting Party',
        author: 'Lucy Foley',
    },
    {
        title: 'The Housemaid is Watching',
        author: 'Freida McFadden',
    },
    {
        title: 'The Picture of Dorian Gray',
        author: 'Oscar Wilde',
    },
    {
        title: 'Atomic Habits',
        author: 'James Clear',
    },
    {
        title: 'Everything I Know About Love: A Memoir',
        author: 'Dolly Alderton',
    },
    {
        title: 'How to End a Love Story: A Novel',
        author: 'Yulin Kuang',
    },
    {
        title: 'Orbital',
        author: 'Samantha Harvey',
    },
    {
        title: 'The Seven Year Slip',
        author: 'Ashley Poston',
    },
    {
        title: 'Harry Potter and the Prisoner of Azkaban',
        author: 'J. K. Rowling',
    },
    {
        title: 'Cleopatra and Frankenstein',
        author: 'Coco Mellors',
    },
    {
        title: 'How to Stop Trying',
        author: 'Kate Williams',
    },
    {
        title: 'Jellyfish Have No Ears',
        author: 'Adèle Rosenfeld',
    },
    {
        title: 'Verity',
        author: 'Colleen Hoover',
    },
    {
        title: 'Severance',
        author: 'Ling Ma',
    },
    {
        title: 'Oh William!',
        author: 'Elizabeth Strout',
    },
    {
        title: `There's Nothing Wrong with Her`,
        author: 'Kate Weinberg',
    },
    {
        title: 'Fake It Like You Mean It: A Novel',
        author: 'Megan Murphy',
    },
    {
        title: 'More Days at the Morisaki Bookshop',
        author: 'Satoshi Yagisawa',
    },
    {
        title: 'Wellness',
        author: 'Nathan Hill',
    },
    {
        title: 'Just for the Summer',
        author: 'Abby Jimenez',
    },
    {
        title: 'Atmosphere: A Love Story',
        author: 'Taylor Jenkins Reid',
    },
    {
        title: 'All the Lovers in the Night',
        author: 'Mieko Kawakami',
    },
    {
        title: 'The Let Them Theory',
        author: 'Mel Robbins',
    },
    {
        title: 'A Woman Among Wolves',
        author: 'Diane K. Boyd',
    },
    {
        title: 'One Golden Summer',
        author: 'Carley Fortune',
    },
    {
        title: 'That Summer',
        author: 'Jennifer Weiner',
    },
    {
        title: 'The Godfather',
        author: 'Mario Puzo',
    },
    {
        title: 'Trees: An Illustrated Celebration',
        author: 'Kelsey Oseid',
    },
    {
        title: 'Night Magic: Adventures Among Glowworms, Moon Gardens, and Other Marvels of the Dark',
        author: 'Leigh Ann Henion',
    },
    {
        title: 'Harry Potter and the Goblet of Fire',
        author: 'J. K. Rowling',
    },
    {
        title: 'If Cats Disappeared from the World',
        author: 'Genki Kawamura',
    },
    {
        title: 'The Dead Romantics',
        author: 'Ashley Poston',
    },
    {
        title: 'The Uncommon Reader',
        author: 'Alan Bennett',
    },
    {
        title: 'Assembly',
        author: 'Natasha Brown',
    },
    {
        title: 'My Name Is Lucy Barton',
        author: 'Elizabeth Strout',
    },
    {
        title: 'The Dogs of Venice',
        author: 'Steven Rowley',
    },
    {
        title: 'What Does It Feel Like?',
        author: 'Sophie Kinsella',
    },
    {
        title: 'The Bookshop',
        author: 'Penelope Fitzgerald',
    },
    {
        title: 'From the Sea',
        author: 'Dan Saladino',
    },
    {
        title: 'And Every Morning the Way Home Gets Longer and Longer: A Novella',
        author: 'Fredrik Backman',
    },
    {
        title: 'Tokyo Ueno Station',
        author: 'Miri Yu',
    },
    {
        title: 'I Know How This Ends: A Novel',
        author: 'Holly Smale',
    },
    {
        title: 'Deep Work',
        author: 'Cal Newport',
    },
    {
        title: 'The Vanishing Half',
        author: 'Brit Bennett',
    },
    {
        title: 'Good Spirits: A Novel',
        author: 'B.K. Borison',
    },
];

const audiobookList = [
    {
        title: 'Be Ready When the Luck Happens: A Memoir',
        author: 'Ina Garten',
    },
    {
        title: 'The Woman in Me',
        author: 'Britney Spears',
    },
    {
        title: 'Master of Me',
        author: 'Keke Palmer',
    },
    {
        title: `Don't Believe Everything You Think`,
        author: 'Joseph Nguyen',
    },
];

const bookPhotos = [
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/thechristmasfix.jpeg',
        altText: 'The Christmas Fix',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/thehuntingparty.jpeg',
        altText: 'The Hunting Party',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/bereadywhentheluckhappens.jpeg',
        altText: 'Be Ready When the Luck Happens: A Memoir',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/thehousemaidiswatching.jpeg',
        altText: 'The Housemaid is Watching',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/thewomaninme.jpeg',
        altText: 'The Woman in Me',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/thepictureofdoriangray.jpeg',
        altText: 'The Picture of Dorian Gray',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/atomichabits.jpeg',
        altText: 'Atomic Habits',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/everythingiknowaboutlove.jpeg',
        altText: 'Everything I Know About Love: A Memoir',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/howtoendalovestory.jpeg',
        altText: 'How to End a Love Story: A Novel',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/orbital.jpeg',
        altText: 'Orbital',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/thesevenyearslip.jpeg',
        altText: 'The Seven Year Slip',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/masterofme.jpeg',
        altText: 'Master of Me',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/harrypotterandtheprisonerofazkaban.jpeg',
        altText: 'Harry Potter and the Prisoner of Azkaban',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/cleopatraandfrankenstein.jpeg',
        altText: 'Cleopatra and Frankenstein',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/dontbelieveeverythingyouthink.jpeg',
        altText: `Don't Believe Everything You Think`,
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/howtostoptrying.jpeg',
        altText: 'How to Stop Trying',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/jellyfishhavenoears.jpeg',
        altText: 'Jellyfish Have No Ears',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/verity.jpeg',
        altText: 'Verity',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/severance.jpeg',
        altText: 'Severance',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/ohwilliam.jpeg',
        altText: 'Oh William!',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/theresnothingwrongwithher.jpeg',
        altText: `There's Nothing Wrong with Her`,
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/fakeitlikeyoumeanit.jpeg',
        altText: 'Fake It Like You Mean It: A Novel',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/moredaysatthemorisakibookshop.jpeg',
        altText: 'More Days at the Morisaki Bookshop',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/wellness.jpeg',
        altText: 'Wellness',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/justforthesummer.jpeg',
        altText: 'Just for the Summer',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/atmosphere.jpeg',
        altText: 'Atmosphere',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/alltheloversinthenight.jpeg',
        altText: 'All the Lovers in the Night',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/theletthemtheory.jpeg',
        altText: 'The Let Them Theory',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/awomanamongwolves.jpeg',
        altText: 'A Woman Among Wolves',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/onegoldensummer.jpeg',
        altText: 'One Golden Summer',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/thatsummer.jpeg',
        altText: 'That Summer',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/thegodfather.jpeg',
        altText: 'The Godfather',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/trees.jpeg',
        altText: 'Trees',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/nightmagic.jpeg',
        altText: 'Night Magic',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/harrypotterandthegobletoffire.jpeg',
        altText: 'Harry Potter and the Goblet of Fire',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/ifcatsdisappearedfromtheworld.jpeg',
        altText: 'If Cats Disappeared from the World',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/thedeadromantics.jpeg',
        altText: 'The Dead Romantics',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/theuncommonreader.jpeg',
        altText: 'The Uncommon Reader',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/assembly.jpeg',
        altText: 'Assembly',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/mynameislucybarton.jpeg',
        altText: 'My Name Is Lucy Barton',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/thedogsofvenice.jpeg',
        altText: 'The Dogs of Venice',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/whatdoesitfeellike.jpeg',
        altText: 'What Does It Feel Like?',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/thebookshop.jpeg',
        altText: 'The Bookshop',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/fromthesea.jpeg',
        altText: 'From the Sea',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/andeverymorning.jpeg',
        altText: 'And Every Morning the Way Home Gets Longer and Longer: A Novella',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/tokyouenostation.jpeg',
        altText: 'Tokyo Ueno Station',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/iknowhowthisends.jpeg',
        altText: 'I Know How This Ends',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/deepwork.jpeg',
        altText: 'Deep Work',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/thevanishinghalf.jpeg',
        altText: 'The Vanishing Half',
    },
    {
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/goodspirits.jpeg',
        altText: 'Good Spirits',
    },
];

const tbrSection = [
    {
        content: `
            My 2025 TBR stack is larger than I expected for the start of the year! I've collected most of these books over a number 
            of trips to different bookstores. I'm looking forward to reading my first book by Abby Jimenez (borrowed from my sister!)—I 
            don't know what's taken me so long! I'm going to continue reading the Harry Potter series; it's my first time reading 
            the actual books. I'm also looking forward to reading the follow-up to the charming Japanese novel "Days at the Morisaki 
            Bookshop" by Satoshi Yagisawa, titled "More Days at the Morisaki Bookshop". I picked up "The Vanishing Half" at a NYC 
            BookTok bus event in December. My friend and I waited over an hour in the freezing cold to snag a free copy of our 
            choice from a selection of popular books on TikTok! My recent obsession with The Sopranos television drama series, and 
            my reading of "Central Park West" by James Comey, prompted me to pick up a copy of "The Godfather". I'll be sure to 
            follow up my reading with a screening of the movies as well. I can't wait to get into these and the other books I've 
            been collecting!`,
        href: 'https://odalys-ruano-personal-site-media.s3.us-east-1.amazonaws.com/reading25/tbrbookstack.jpeg',
        altText: "2025 TBR Book Stack"
    },
];

// should be of ReadingPageProps type
// see /src/pages/ReadingPage/ReadingPage.tsx
export default {
    year, 
    summary, 
    bookList, 
    audiobookList,
    bookPhotos,
    tbrSection,
};
